import { gql } from 'graphql-request'

export namespace HomeQualityCheckMutations {
  export function startHomeQualityCheck() {
    return gql`
      mutation startHomeQualityCheck($homeQualityCheckId: Int!, $geolocation: GeolocationInput) {
        startHomeQualityCheck(homeQualityCheckId: $homeQualityCheckId, geolocation: $geolocation)
      }
    `
  }

  export function createHomeQualityCheck() {
    return gql`
      mutation createHomeQualityCheck($homeQualityCheck: HomeQualityCheckInsertMutation!) {
        createHomeQualityCheck(homeQualityCheck: $homeQualityCheck) {
          id
        }
      }
    `
  }

  export function updateHomeQualityCheck() {
    return gql`
      mutation updateHomeQualityCheck(
        $homeQualityCheck: HomeQualityCheckUpdateMutation!
        $attachments: [Upload!]
        $geolocation: GeolocationInput
      ) {
        updateHomeQualityCheck(
          homeQualityCheck: $homeQualityCheck
          attachments: $attachments
          geolocation: $geolocation
        ) {
          id
        }
      }
    `
  }

  export function createHostRating() {
    return gql`
      mutation createHostRating($homeQualityCheckId: Int!, $rating: Int!, $comments: [String]) {
        createHostRating(homeQualityCheckId: $homeQualityCheckId, rating: $rating, comments: $comments)
      }
    `
  }
}
